import React, { useContext, useEffect } from "react";
import { Navigate } from "react-router-dom";
import { UnifiedServiceProvider } from "../../../utilities/contexts/UnifiedServiceContext";
import UnifiedService from "../../services/UnifiedService";
import SdkContext from "../../../utilities/contexts/sdk/sdkContext";
import { getSdkServiceConfig, isValidSdkServiceType } from "../../../utilities/helpers/sdkServiceMapper";
import { SdkResultsHandler } from "../../../utilities/hooks/useSdkResultsHandler";

const SdkUnifiedService: React.FC = () => {
  const sdkContext = useContext(SdkContext);

  if (!sdkContext.token) {
    localStorage.clear();
    return <Navigate to="/sdk/accessDenied" />;
  }

  if (!isValidSdkServiceType(sdkContext.serviceType || "")) {
    localStorage.clear();
    return <Navigate to="/sdk/accessDenied" />;
  }

  const serviceConfig = getSdkServiceConfig(sdkContext.serviceType || "");

  return (
    <UnifiedServiceProvider config={serviceConfig}>
      <SdkResultsHandler>
        <SdkServiceContainer />
      </SdkResultsHandler>
    </UnifiedServiceProvider>
  );
};

const SdkServiceContainer: React.FC = () => {
  return <UnifiedService />;
};

export default SdkUnifiedService;
